export default __webpack_public_path__ + "static/media/appointyPreloader.e003f2d9.gif";